import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CustomerAddressList, CustomerVM } from 'src/app/models/customer/customer.model';
import { CheckoutDataVM, ProductModel } from 'src/app/models/Home/home-list.model';
import { GetProductAssetModel } from 'src/app/models/product/productAssets.modal';
import { QuoteItemModel } from 'src/app/models/quoteModel/quote.model';
import { CustomerAddressAddComponent } from 'src/app/modules/layoutModule/components/customer/customer-address-add/customer-address-add.component';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { QuoteService } from 'src/app/services/quote.service';

@Component({
  selector: 'app-request-quote',
  templateUrl: './request-quote.component.html',
  styleUrls: ['./request-quote.component.css']
})
export class RequestQuoteComponent implements OnInit {

  @Input('fileType') FileType: string = '1';
  productAssets: GetProductAssetModel = new GetProductAssetModel();
  productImageResponseModel: Array<GetProductAssetModel> = new Array<GetProductAssetModel>();
  ShowImageinMainFrame: GetProductAssetModel = new GetProductAssetModel();
  productDetail: ProductModel = new ProductModel();
  customerListVM: CustomerAddressList = new CustomerAddressList();
  productId: number;
  addressAdd: boolean = true;
  isQuoteRequest: boolean;
  Loader: boolean = false;
  orderShow: boolean = false;
  selectedAddress: number;
  selectedAddressInfo: CustomerVM = new CustomerVM();
  selectSingleAddress: boolean = false;
  quoteModel: QuoteItemModel = new QuoteItemModel();
  addrssLoader: boolean = false;
  addQuoteLoder: boolean = false;
  imageLoader: boolean = false;
  quoteInput: string;
  successfulQuote: boolean = false;
  addQuoteHide: boolean = true;
  passValue: number;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private requestQuote: QuoteService, private modalService: NgbModal, private alertify: AlertifyService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe((param) => {
      this.productId = +param.productId;
    });
    this.productImage(this.FileType);
    this.getProductAssetsContent();
    this.customerAddressList();
  }
  inputQuote(e) {
    if ((e <= 0) && (e !== "")) {
      this.quoteInput = "Please Input Correct Quantity";
    }
    else {
      this.quoteInput = "";
    }
  }

  productImage(FileType) {
    this.productAssets.ImageLoader = true;
    this.productAssets.ProductId = this.productId;
    this.productAssets.FileType = FileType;
    this.requestQuote.GetProductImage(this.productAssets)
      .subscribe((response) => {
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.productAssets.ImageLoader = false;
          this.productImageResponseModel = responseBody.responseData;
          this.FileType = this.productImageResponseModel[0].type.toLocaleString();
          this.ShowImageinMainFrame = this.productImageResponseModel[0];
        }
      })
  }

  getProductAssetsContent() {
    this.Loader = true;
    this.productAssets.ProductId = this.productId;
    this.requestQuote.GetProductDetail(this.productAssets)
      .subscribe((response) => {
        this.Loader = false;
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.productDetail = responseBody.responseData;
          this.isQuoteRequest = this.productDetail.isQuote;
        } (err) => {
          this.Loader = false;
        }
      })
  }

  customerAddressList() {
    this.Loader = true;
    this.requestQuote.CustomerAddressList().subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.customerListVM.CustomerList = responseBody.responseData;
        this.Loader = false;
      } (err) => {
      }
    });
  }

  addAddress() {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    let modalRef = this.modalService.open(CustomerAddressAddComponent, modalConfig);
    modalRef.componentInstance.ProductId = this.productId;
    modalRef.result.then(() => {
    }, (reason) => {
      this.customerAddressList();
      this.Loader = false;
    })
  }

  selectAddress(item, index) {
    this.addrssLoader = true;
    this.addressAdd = true;
    this.customerListVM.CustomerList.forEach(address => {
      address.IsSelected = false;
    });
    this.addressAdd = false;
    this.customerListVM.CustomerList[index].IsSelected = true;
    this.orderShow = false;
    this.productAssets.ProductId = this.productId;
    this.selectedAddress = item.id;
    this.selectedAddressInfo = item;
    this.selectSingleAddress = true;
    this.addrssLoader = false;
    this.orderShow = true;

  }


  addQuote() {
    if (this.quoteModel.Quantity == undefined || this.quoteModel.Quantity == null || this.quoteModel.Quantity.toString() == "") {
      this.alertify.error("Quantity is required");
      return;
    }
    this.quoteModel.Quantity = this.quoteModel.Quantity;
    this.addQuoteLoder = true;
    this.quoteModel.AddressId = this.selectedAddress;
    this.quoteModel.ProductId = this.productId;
    this.requestQuote.CustomerQuoteAdd(this.quoteModel)
      .subscribe((response) => {
        let responseBody = JSON.parse(response._body)
        this.addQuoteLoder = false;
        this.addQuoteHide = false;
        this.successfulQuote = true;
        if (responseBody.isSuccess) {
          this.alertify.success(responseBody.responseMessage);
        } else {
          this.alertify.error(responseBody.responseMessage);
        }
      });
  }

  continueShopping() {
    this.router.navigate(['/home-page']);
  }

  changeAddress() {
    this.orderShow = false;
    this.addressAdd = true;
  }

  productAssetsImage() {
    this.router.navigate(['/product-page/' + this.productId])
  }
}
